import 'react-app-polyfill/ie9'; // IE지원
import "babel-polyfill"; // IE지원
import 'core-js/es/set'; // IE지원
import 'core-js/es/map'; // IE지원
import React from 'react';
import ReactDOM from 'react-dom';
import Root from './client/Root';
import registerServiceWorker from './registerServiceWorker';
//import { unregister } from './registerServiceWorker';
import { AppContainer } from 'react-hot-loader';
import '../src/css/common.css'
import '../src/css/notfound.css'

ReactDOM.render(
  <AppContainer>
    <Root/>
  </AppContainer>,
  document.getElementById('root')
);

if(module.hot) {
  module.hot.accept('./client/Root', () => {
    const NextRoot = require('./client/Root').default;
    ReactDOM.render(
      <AppContainer>
        <NextRoot/>
      </AppContainer>,
      document.getElementById('root')
    );
  });
}

registerServiceWorker();
//unregister();



// WEBPACK FOOTER //
// ./src/index.js